"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var prismicElements = {
  heading1: {
    typeMod: 'heading1',
    Tag: 'h1',
    classMod: '__heading-1'
  },
  heading2: {
    typeMod: 'heading2',
    Tag: 'h2',
    classMod: '__heading-2'
  },
  heading3: {
    typeMod: 'heading3',
    Tag: 'h3',
    classMod: '__heading-3'
  },
  heading4: {
    typeMod: 'heading4',
    Tag: 'h4',
    classMod: '__heading-4'
  },
  heading5: {
    typeMod: 'heading5',
    Tag: 'h5',
    classMod: '__heading-5'
  },
  heading6: {
    typeMod: 'heading6',
    Tag: 'h6',
    classMod: '__heading-6'
  },
  hyperlink: {
    typeMod: 'hyperlink',
    Tag: 'a',
    classMod: '__link'
  },
  'group-list-item': {
    typeMod: 'group-list-item',
    Tag: 'ul',
    classMod: '-list--unordered'
  },
  'group-o-list-item': {
    typeMod: 'group-o-list-item',
    Tag: 'ol',
    classMod: '-list--ordered'
  },
  'list-item': {
    typeMod: 'list-item',
    Tag: 'li',
    classMod: '-list__item'
  },
  'o-list-item': {
    typeMod: 'o-list-item',
    Tag: 'li',
    classMod: '-list__item'
  },
  paragraph: {
    typeMod: 'paragraph',
    Tag: 'p',
    classMod: '__copy'
  },
  span: {
    typeMod: 'span',
    Tag: 'span',
    classMod: '--span'
  },
  strong: {
    typeMod: 'strong',
    Tag: 'span',
    classMod: '--strong'
  },
  em: {
    typeMod: 'em',
    Tag: 'span',
    classMod: '--em'
  },
  embed: {
    typeMod: 'embed',
    Tag: 'div',
    classMod: '--embed'
  },
  image: {
    typeMod: 'image',
    Tag: 'img',
    classMod: '__image'
  }
};
var _default = prismicElements;
exports["default"] = _default;